<!-- TODO: GET COLOR FROM THEME SOMEHOW -->
<ngx-loading-bar color="#0b1d4b" [includeSpinner]="false"></ngx-loading-bar>

<app-header *ngIf="(isAuthenticated | async)"></app-header>

<router-outlet></router-outlet>
